<template>

	<div class="input-container">
		<button class="add-latex" @click.prevent="isPopUpLatexVisible = !isPopUpLatexVisible">f(x)</button>

		<div class="fake-textarea" :id="customId" contenteditable></div>

	</div>
	<Teleport to="body">
		<PopUpInsertLatex @close="isPopUpLatexVisible = !isPopUpLatexVisible" @insert-latex="insertLatexText"
			v-if="isPopUpLatexVisible" />
	</Teleport>
</template>

<script>
import PopUpInsertLatex from '../PopUp/SeriousGame/TileGame/PopUpInsertLatex.vue'


export default {
	components: {
		PopUpInsertLatex
	},
	props:{
		customId: String,
		text: {
			type: String,
			default: ''
		}
	},
	emits: ['update-text'],
	data() {
		return {
			isPopUpLatexVisible: false,
			carretPosition: 0,
			savedRange: null,
		}
	},
	methods: {
		updateCarretPosition() {
			return new Promise((resolve) => {
				setTimeout(() => {
					const selection = window.getSelection()
					if (selection.rangeCount > 0) {
						const range = selection.getRangeAt(0)
						this.carretPosition = range.startOffset
					}
					resolve()
				}, 200)
			})
		},
		insertLatexText(latex) {
			this.isPopUpLatexVisible = false;
			const mathField = document.createElement('math-field');
			mathField.setAttribute('readonly', '');
			mathField.setAttribute('class', 'mathfield');
			mathField.setAttribute('contenteditable', false);
			mathField.textContent = latex;
			mathField.style.cursor = 'pointer';

			const text = document.getElementById(this.customId);
			text.focus();

			this.restoreSelection(); // <-- Ajouté

			const selection = window.getSelection();
			if (selection.rangeCount > 0) {
				const range = selection.getRangeAt(0);
				range.collapse(false); // Place à la position du caret
				range.insertNode(mathField);
				// Optionnel : ajouter un espace après
				range.setStartAfter(mathField);
				const space = document.createTextNode('\u00A0');
				range.insertNode(space);
				// Mettre le caret après l'espace
				range.setStartAfter(space);
				range.collapse(true);
				selection.removeAllRanges();
				selection.addRange(range);
			}

			this.$emit('update-text', this.removeLastBr(text.innerHTML));
		},
		removeLastBr(str) {
			const brTag = '<br>';
			const lastIndex = str.lastIndexOf(brTag);

			if (lastIndex !== -1) {
				return str.substring(0, lastIndex) + str.substring(lastIndex + brTag.length);
			}
			
			return str;
		},
		saveSelection() {
			const selection = window.getSelection()
			if (selection.rangeCount > 0) {
				this.savedRange = selection.getRangeAt(0).cloneRange()
			}
		},
		restoreSelection() {
			const selection = window.getSelection()
			selection.removeAllRanges()
			if (this.savedRange) {
				selection.addRange(this.savedRange)
			}
		},
	},
	
	mounted() {
		this.$nextTick(() => {
			const text = document.getElementById(this.customId)
			text.innerHTML = this.text
			text.addEventListener('input', async () => {
				await this.updateCarretPosition()
				this.saveSelection()
				this.$emit('update-text', this.removeLastBr(text.innerHTML))
			})
			text.addEventListener('click', async () => {
				await this.updateCarretPosition()
				this.saveSelection()
			})
			text.addEventListener('keyup', () => {
				this.saveSelection()
			})
		})
	},

}
</script>

<style lang="scss" setup>

.input-container{
	position: relative;
	.add-latex {
		position: absolute;
		top: 0;
		left: 50%;
		translate: -50% -50%;
		background-color: #fefefe;
		border: solid 2px #000;
		border-radius: 15px;
		padding: 0.5rem 1rem;
		cursor: pointer;
	}
}
.fake-textarea {
	width: 100%;
	height: 100%;
	min-height: 150px;
	padding: 2rem;
	background-color: white;
	border: none;
	border-radius: 15px;
	resize: none;
	font-size: small;
	
}
</style>
